import AboutMe from './AboutMe';
import AddBlogPost from './AddBlogPost';
import PostTableView from './PostTableView';
import EditBlogPost from './EditBlogpost';

const routes = [
  { path: "view", component: PostTableView },
  { path: "create", component: AddBlogPost },
  { path: "about", component: AboutMe },
  { path: "editblog/:id", component: EditBlogPost }
]

export default routes;


// WEBPACK FOOTER //
// ./src/views/Blog/Post/routes.js